/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Volume_HeadlineInputs */

const en_us2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lifted`)
};

const pt_br2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantadas`)
};

const es_419_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantadas`)
};

const pt_pt2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`levantadas`)
};

const fr_fr2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`soulevées`)
};

const de_de2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bewegt`)
};

const it_it2_wrapped_volume_headline = /** @type {(inputs: Wrapped_Volume_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sollevate`)
};

/**
* | output |
* | --- |
* | "lifted" |
*
* @param {Wrapped_Volume_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_headline = /** @type {((inputs?: Wrapped_Volume_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_headline(inputs)
	return en_us2_wrapped_volume_headline(inputs)
});
export { wrapped_volume_headline as "wrapped.volume_headline" }